import Fuse from 'fuse.js'

export const initialFuse = (list, options) => new Fuse(list, options)
